import { combineReducers } from 'redux';
import activeTab from './active-tab/active-tab';
import selectedLanguage from './selected-language/selected-language';
import pagination from './pagination/pagination';
import sosPagination from './pagination/sosPagination';
import sortingFunction from './sorting-function/sorting-function';
import error from './error/error';
import { createNamedReducer } from './createNamedReducer';

const ui = combineReducers({
  activeTab: createNamedReducer(activeTab, 'activeTab'),
  detailsDialogActiveTab: createNamedReducer(activeTab, 'detailsDialogActiveTab'),
  endingGamesActiveTab: createNamedReducer(activeTab, 'endingGamesActiveTab'),
  selectedLanguage,
  pagination,
  sosPagination,
  sortingFunction,
  error,
});

export default ui;



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/ui.reducer.js